/**
 * Constantes del componente NavigationProgress.
 * Definidas en su propio fichero (convención del repo).
 */

/** Nombre accesible del spinner de transición de página. */
export const LOADING_LABEL = "Cargando página";
